module.exports = __webpack_public_path__ + "static/media/profile_white.71e29d36.svg";